// src/components/DownloadButtonReport.js

import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ReportPDF from "./RepasseReportPDFConsultEmergency.js"; // AJUSTE este caminho se necessário

const DownloadButton = ({ dataPayments, professionals }) => {
  return (
    <PDFDownloadLink
      document={
        <ReportPDF payment={dataPayments} professionals={professionals} />
      }
      fileName="relatorio_distribuicao_receita(Consultas).pdf">
      {({ loading }) => (loading ? "Gerando PDF..." : "Baixar PDF")}
    </PDFDownloadLink>
  );
};

export default DownloadButton;
